import React from "react";

import classes from "./CardOverlay.module.css";
export default function CardOverlay(props) {
  return <div {...props} className={`${classes.overlay} ${[props?.className]}`} ></div>;
}
